(function () {
  "use strict";

  // ── Constants ──────────────────────────────────────────────
  const FOOTER_SEL = ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML";
  const BUTTONS_SEL = ".gbbFooterButtonsWrapper, .gbbFooterButtonsContainer";

  // ── Helpers ────────────────────────────────────────────────
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => root.querySelectorAll(sel);

  function getFooter() { return $(FOOTER_SEL); }

  function getTotalSteps() {
    try {
      const cond = window.tmpCartSettings2?.stepsConfigurationData?.productsData1?.conditions?.[0];
      if (cond?.type === "quantity") return parseInt(cond.value, 10) || 4;
    } catch (_) { }
    return 4;
  }

  function stripDecimals(el) {
    if (el && el.textContent.includes(".00"))
      el.textContent = el.textContent.replace(".00", "");
  }

  // ── Stepper HTML ───────────────────────────────────────────
  function generateStepperHTML(totalSteps) {
    const steps = Array.from({ length: totalSteps }, (_, i) => {
      const n = i + 1;
      return `
        <div class="bundle-app-new-step" id="bundle-app-new-step-${n}">
          <div class="bundle-app-new-step-box">${n}</div>
          <div class="bundle-app-new-step-label">Select your</div>
          <div class="bundle-app-new-step-sublabel">Item ${n}</div>
        </div>
        ${n < totalSteps ? '<div class="bundle-app-new-connector"></div>' : ""}`;
    }).join("");

    return `
      <div id="bundle-app-new-stepper-root" class="bundle-app-new-stepper-container" data-total-steps="${totalSteps}">
        <div class="bundle-app-new-spacer"></div>
        ${steps}
        <div class="bundle-app-new-spacer"></div>
        <div class="bundle-app-new-arrow-icon">
          <svg width="30" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>`;
  }

  // ── Stepper inject ─────────────────────────────────────────
  function injectStepper(footer, totalSteps) {
    if ($('#bundle-app-new-stepper-root')) return;

    const buttonsWrapper = $(BUTTONS_SEL, footer);
    const innerContainer = Array.from(footer.children).find(c => c.tagName === "DIV") || footer;

    const tmp = document.createElement("div");
    tmp.innerHTML = generateStepperHTML(totalSteps);
    const stepper = tmp.firstElementChild;

    if (buttonsWrapper?.parentElement) {
      buttonsWrapper.parentElement.insertBefore(stepper, buttonsWrapper);
    } else {
      innerContainer.appendChild(stepper);
    }

    const parent = stepper.parentElement;
    if (parent) Object.assign(parent.style, {
      display: "flex", flexWrap: "nowrap", alignItems: "center",
      justifyContent: "space-between", width: "100%"
    });

    // Ensure the stepper itself uses flex-start to align connectors with boxes
    Object.assign(stepper.style, {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center"
    });
  }

  // ── Side Panel: HTML generation ─────────────────────────────────────────────
  function generateSidePanelHTML(totalSteps) {
    const steps = Array.from({ length: totalSteps }, (_, i) => {
      const n = i + 1;
      return `
        <div class="bundle-side-step" id="bundle-side-step-${n}">
          <div class="bundle-side-step-icon">+</div>
          <span class="bundle-side-step-label">Select Your Item ${n}</span>
        </div>`;
    }).join("");

    return `
      <div class="bundle-side-stepper-title">Customized Your Bundle</div>
      <div id="bundle-side-steps-root">${steps}</div>
      <div id="bundle-side-price" class="bundle-side-price">
        <span id="bundle-side-price-original" class="bundle-side-price-original"></span>
        <span id="bundle-side-price-discounted" class="bundle-side-price-discounted">₹0</span>
      </div>
      <button id="bundle-side-add-to-cart-btn" class="bundle-side-add-to-cart bundle-app-disabled-btn">
        <span>ADD TO CART</span>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`;
  }

  // ── Side Panel: inject ────────────────────────────────────────────────────
  function injectStepperSidebar(totalSteps) {
    if ($('#bundle-sticky-stepper-panel')) return;

    const productsContainer = $('.gbbProductsItemsContainer');
    if (!productsContainer) return;

    // Create the flex wrapper that will sit between the full-width tabs above
    // and hold [products | stepper] side by side
    const wrapper = document.createElement('div');
    wrapper.id = 'bundle-layout-wrapper';

    productsContainer.parentNode.insertBefore(wrapper, productsContainer);
    wrapper.appendChild(productsContainer);

    // Create and append the sticky stepper panel
    const panel = document.createElement('div');
    panel.id = 'bundle-sticky-stepper-panel';
    panel.innerHTML = generateSidePanelHTML(totalSteps);
    wrapper.appendChild(panel);

    // Wire the sidebar add-to-cart button to the native hidden button
    const addToCartBtn = $('#bundle-side-add-to-cart-btn');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {
        const nativeBtn = $('.gbbFooterNextButton');
        if (nativeBtn) nativeBtn.click();
      });
    }
  }

  // ── Side Panel: sync state ──────────────────────────────────────────────
  function syncSidePanelState() {
    const panel = $('#bundle-sticky-stepper-panel');
    if (!panel) return;

    const footer = getFooter();
    const totalSteps = getTotalSteps();
    const filledSlots = [];

    if (footer) {
      $$('.gbbFooterProductContainer', footer).forEach((product, index) => {
        const qtyText = $('.gbbFooterProductQuantity', product)?.innerText?.trim() ?? 'x1';
        const qty = parseInt(qtyText.match(/x?(\d+)/)?.[1] ?? 1, 10);
        const imgSrc = $('.gbbFooterProductImage', product)?.src ?? '';
        const name = $('.gbbFooterProductTitle', product)?.textContent?.trim() ?? '';
        for (let k = 0; k < qty; k++) filledSlots.push({ productIndex: index, img: imgSrc, name });
      });
    }

    for (let i = 0; i < totalSteps; i++) {
      const stepNode = $(`#bundle-side-step-${i + 1}`);
      if (!stepNode) continue;

      const slotData = filledSlots[i];
      if (slotData) {
        stepNode.classList.add('filled');
        stepNode.classList.remove('active');
        stepNode.innerHTML = `
          <img src="${slotData.img}" class="bundle-side-step-thumb" alt="Product">
          <div class="bundle-side-step-info">
            <div class="bundle-side-step-sublabel">Item ${i + 1}</div>
            <div class="bundle-side-step-name">${slotData.name || 'Item selected'}</div>
          </div>
          <button class="bundle-side-step-remove" data-product-index="${slotData.productIndex}">✕</button>`;
      } else {
        stepNode.classList.remove('filled');
        stepNode.classList.toggle('active', i === filledSlots.length);
        stepNode.innerHTML = `
          <div class="bundle-side-step-icon">+</div>
          <span class="bundle-side-step-label">Select Your Item ${i + 1}</span>`;
      }
    }

    const addToCartBtn = $('#bundle-side-add-to-cart-btn');
    if (addToCartBtn) {
      const complete = filledSlots.length === totalSteps;
      addToCartBtn.classList.toggle('bundle-app-disabled-btn', !complete);
      addToCartBtn.disabled = !complete;
    }

    // ── Sync price display ──────────────────────────────────────
    const priceBlock = $('#bundle-side-price');
    const priceOrigEl = $('#bundle-side-price-original');
    const priceDiscEl = $('#bundle-side-price-discounted');
    if (priceBlock && priceOrigEl && priceDiscEl) {
      // Always show the price block
      priceBlock.style.display = 'flex';

      if (footer && filledSlots.length > 0) {
        const totalContainer = $('.gbbFooterTotalContainer', footer);
        const origEl = totalContainer && $('.gbbFooterOriginalTotalValue', totalContainer);
        const discEl = totalContainer && $('.gbbFooterDiscountedTotalValue', totalContainer);

        const discText = discEl ? discEl.textContent.replace('.00', '').trim() : '';
        const origText = origEl ? origEl.textContent.replace('.00', '').trim() : '';

        priceDiscEl.textContent = discText || '\u20B90';
        const showOrig = origText && origText !== discText;
        priceOrigEl.textContent = showOrig ? origText : '';
        priceOrigEl.style.display = showOrig ? 'inline' : 'none';
      } else {
        // Empty stepper — show ₹0
        priceDiscEl.textContent = '\u20B90';
        priceOrigEl.textContent = '';
        priceOrigEl.style.display = 'none';
      }
    }
  }

  // ── Sync stepper state ─────────────────────────────────────
  function syncStepperState() {
    if (window.bundleAppSyncing) return;
    window.bundleAppSyncing = true;

    try {
      const footer = getFooter();
      if (!footer) return;

      const totalSteps = getTotalSteps();
      const existingRoot = $('#bundle-app-new-stepper-root');

      if (existingRoot) {
        if (parseInt(existingRoot.dataset.totalSteps || 0) !== totalSteps) {
          existingRoot.remove();
          injectStepper(footer, totalSteps);
          return;
        }
      } else {
        injectStepper(footer, totalSteps);
      }

      // Build filled slots from footer products
      const filledSlots = [];
      $$('.gbbFooterProductContainer', footer).forEach((product, index) => {
        const qtyText = $('.gbbFooterProductQuantity', product)?.innerText?.trim() ?? "x1";
        const qty = parseInt(qtyText.match(/x?(\d+)/)?.[1] ?? 1, 10);
        const imgSrc = $('.gbbFooterProductImage', product)?.src ?? "";
        for (let k = 0; k < qty; k++) filledSlots.push({ productIndex: index, img: imgSrc });
      });

      if (filledSlots.length > 0) {
        window.bundleAppStepperOpen = true;
        if (typeof updateMobileFooterVisibility === 'function') updateMobileFooterVisibility();
      }

      // Update each step
      for (let i = 0; i < totalSteps; i++) {
        const stepNode = $(`#bundle-app-new-step-${i + 1}`);
        if (!stepNode) continue;

        const stepBox = $('.bundle-app-new-step-box', stepNode);
        const slotData = filledSlots[i];

        if (slotData) {
          if (!stepNode.classList.contains("filled")) {
            stepNode.classList.remove("active");
            stepNode.classList.add("filled");
            stepBox.innerHTML = `
              <img src="${slotData.img}" class="bundle-app-new-step-img" alt="Selected Product">
              <div class="bundle-app-new-step-close" data-product-index="${slotData.productIndex}">✕</div>`;
          } else {
            const img = $('img', stepBox);
            if (img && img.src !== slotData.img) img.src = slotData.img;
            const btn = $('.bundle-app-new-step-close', stepBox);
            if (btn) btn.dataset.productIndex = slotData.productIndex;
          }
          // Remove any stray shadow from the circle
          stepBox.style.removeProperty('filter');
          stepBox.style.removeProperty('box-shadow');
          stepBox.style.setProperty('border', 'none', 'important');
          stepBox.style.setProperty('padding', '0', 'important');
          stepBox.style.setProperty('overflow', 'visible', 'important');
        } else {
          if (stepNode.classList.contains("filled")) {
            stepNode.classList.remove("filled");
            stepBox.innerHTML = `${i + 1}`;
            stepBox.style.removeProperty('filter');
            stepBox.style.removeProperty('box-shadow');
          }
          stepNode.classList.toggle("active", i === filledSlots.length);
        }
      }

      // Button state
      const nextBtn = $('.gbbFooterNextButton');
      if (nextBtn) {
        clearButtonText(nextBtn);
        const complete = filledSlots.length === totalSteps;
        nextBtn.classList.toggle("bundle-app-disabled-btn", !complete);
        nextBtn.disabled = !complete;
      }

      showcasePrices(footer);
      syncSidePanelState();
    } finally {
      window.bundleAppSyncing = false;
    }
  }

  // ── Clear "Next" text from button ──────────────────────────
  function clearButtonText(btn) {
    const nextBtn = btn || $('.gbbFooterNextButton');
    if (!nextBtn) return;
    const text = (nextBtn.textContent || "").trim().toUpperCase();
    if (text && !text.includes("ADD TO CART")) nextBtn.textContent = "";
    Array.from(nextBtn.childNodes).forEach(node => {
      if (node.nodeType === 3 && node.textContent.trim()) node.textContent = "";
    });
  }

  // ── Discount tags ──────────────────────────────────────────
  function injectDiscountTags() {
    $$(".gbbProductItemPricesContainer, .gbbProductVariantModalMainContainer").forEach(container => {
      if ($('.gbbProductDiscountTag', container)) return;

      const priceEl = $('.gbbProductItemPrice', container);
      const compareEl = $('.gbbProductItemCompareAtPrice', container);
      if (!priceEl || !compareEl) return;

      stripDecimals(priceEl);
      stripDecimals(compareEl);

      const price = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ""));
      const compare = parseFloat(compareEl.textContent.replace(/[^\d.]/g, ""));
      if (isNaN(price) || isNaN(compare) || compare <= price) return;

      const discount = Math.round(((compare - price) / compare) * 100);
      if (discount <= 0) return;

      const tag = document.createElement("span");
      tag.className = "gbbProductDiscountTag";
      tag.textContent = `(${discount}% OFF)`;
      compareEl.after(tag);
    });
  }

  // ── Select → tabs ──────────────────────────────────────────
  function convertSelectToTabs() {
    const banners = window.bundleBannerData || {};
    if (!banners.show_different_tabs) return;

    const wrapper = $(".gbbAddGiftBoxPageWrapper, .gbbProductsItemsContainer");
    if (!wrapper) return;

    $$("select", wrapper).forEach(select => {
      if (select.dataset.tabsInitialized) return;
      select.style.display = "none";
      select.dataset.tabsInitialized = "true";

      $$('svg', select.parentNode).forEach(svg => svg.style.display = "none");

      const tabsContainer = document.createElement("div");
      tabsContainer.className = "bundle-custom-tabs-container";

      Array.from(select.options).forEach(option => {
        const cleanText = option.text.replace(/[\u25BC\u25B2\u2304\u2303▼▲⌄⌃˅^]/g, "").trim();
        if (!cleanText) return;

        const tab = document.createElement("button");
        tab.className = "bundle-custom-tab" + (option.selected ? " active" : "");
        tab.textContent = cleanText;

        tab.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          $$(".bundle-custom-tab", tabsContainer).forEach(t => t.classList.remove("active"));
          tab.classList.add("active");
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });

        tabsContainer.appendChild(tab);
      });

      select.before(tabsContainer);
    });
  }

  // ── Size chart ─────────────────────────────────────────────
  function injectSizeChart() {
    const modal = $(".gbbProductVariantModalMainContainer");
    if (!modal || $('.bundle-size-chart-link', modal)) return;

    const titleEl = $('.gbbProductItemTitle', modal);
    if (!titleEl) return;

    const titleText = titleEl.textContent.toLowerCase();
    let chartUrl = "";

    if (window.bundlePageSizeCharts) {
      const allTabs = $$("button, a, span, div, .eb-category-item");
      let activeCategory = "";
      let foundAnyTab = false;

      for (const el of allTabs) {
        const txt = el.textContent.toLowerCase().trim();
        if (txt !== "men" && txt !== "women") continue;
        foundAnyTab = true;
        const isActive = el.classList.contains("active") || el.classList.contains("selected") ||
          el.parentElement.classList.contains("active") || el.parentElement.classList.contains("selected") ||
          el.getAttribute("aria-selected") === "true";
        if (isActive) { activeCategory = txt; break; }
      }

      if (!foundAnyTab) {
        chartUrl = window.bundlePageSizeCharts.men || "";
      } else if (activeCategory === "women" || titleText.includes("women")) {
        chartUrl = window.bundlePageSizeCharts.women || "";
      } else if (activeCategory === "men" || titleText.includes("men")) {
        chartUrl = window.bundlePageSizeCharts.men || "";
      }
    }

    if (!chartUrl || chartUrl.includes("no-image") || chartUrl.includes("undefined")) return;

    const link = document.createElement("a");
    link.className = "bundle-size-chart-link";
    link.textContent = "Size Chart";
    link.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
      showSizeChartModal(chartUrl);
    });

    const sizeLabel = $('.gbbProductVariantOptionContainer[optionid="Size"] .gbbProductVariantOptionLabelContainer', modal);
    if (sizeLabel) {
      Object.assign(sizeLabel.style, { display: "flex", justifyContent: "space-between", alignItems: "center" });
      sizeLabel.appendChild(link);
    } else {
      const anchor = $('.gbbProductItemPricesContainer', modal) || titleEl;
      anchor.after(link);
    }
  }

  function showSizeChartModal(url) {
    let modal = $('#bundle-size-chart-popup');
    if (!modal) {
      modal = document.createElement("div");
      modal.id = "bundle-size-chart-popup";
      modal.className = "bundle-size-chart-modal";
      modal.innerHTML = `
        <div class="bundle-size-chart-content">
          <span class="bundle-size-chart-close">&times;</span>
          <img class="bundle-size-chart-img" src="" alt="Size Chart">
        </div>`;
      document.body.appendChild(modal);
      $('.bundle-size-chart-close', modal).addEventListener("click", () => modal.style.display = "none");
      modal.addEventListener("click", e => { if (e.target === modal) modal.style.display = "none"; });
    }
    $('.bundle-size-chart-img', modal).src = url;
    modal.style.display = "flex";
  }

  // ── Prices in footer ───────────────────────────────────────
  function showcasePrices(footer) {
    if (!footer || window.bundleAppShowcasingPrices) return;
    window.bundleAppShowcasingPrices = true;

    try {
      clearButtonText();

      const totalContainer = $('.gbbFooterTotalContainer', footer);
      if (!totalContainer) return;

      const isMobile = window.innerWidth <= 900;
      const totalLabel = $('.gbbFooterTotalLabel', totalContainer);

      // On mobile: show the "Total:" label; on desktop: hide it (sidebar handles pricing display)
      if (totalLabel) totalLabel.style.display = isMobile ? 'block' : 'none';

      Object.assign(totalContainer.style, { display: 'flex', visibility: 'visible' });

      const origEl = $('.gbbFooterOriginalTotalValue', totalContainer);
      const discEl = $('.gbbFooterDiscountedTotalValue', totalContainer);
      const valContainer = $('.gbbFooterTotalValueContainer', totalContainer);

      [origEl, discEl].forEach(el => {
        if (!el) return;
        stripDecimals(el);
        Object.assign(el.style, { display: 'block', visibility: 'visible' });
      });

      if (valContainer) Object.assign(valContainer.style, {
        display: 'flex', flexDirection: 'row', alignItems: 'center',
        justifyContent: isMobile ? 'flex-start' : 'center', gap: '4px', visibility: 'visible'
      });

      const buttonsWrapper = $(BUTTONS_SEL, footer);
      if (buttonsWrapper && totalContainer.parentElement !== buttonsWrapper) {
        const nextBtn = $('.gbbFooterNextButton', buttonsWrapper);
        let referenceNode = nextBtn;
        while (referenceNode && referenceNode.parentNode !== buttonsWrapper) {
          referenceNode = referenceNode.parentNode;
        }
        buttonsWrapper.insertBefore(totalContainer, referenceNode || buttonsWrapper.firstChild);
      }
    } finally {
      setTimeout(() => { window.bundleAppShowcasingPrices = false; }, 100);
    }
  }

  // ── Click delegation ───────────────────────────────────────
  function handleStepperClick(e) {
    const closeBtn = e.target.closest(".bundle-app-new-step-close, .bundle-side-step-remove");
    if (!closeBtn) return;

    const index = parseInt(closeBtn.dataset.productIndex, 10);
    const footer = getFooter();
    if (!footer) return;

    const product = $$('.gbbFooterProductContainer', footer)[index];
    const removeBtn = product && $('.gbbFooterProductRemoveButton', product);
    if (removeBtn) removeBtn.click();
  }

  // ── Mobile "Create A Bundle" button ────────────────────────
  function initMobileCreateButton() {
    if ($('#bundle-mobile-create-btn')) return;
    const btn = document.createElement('div');
    btn.id = 'bundle-mobile-create-btn';
    btn.textContent = 'Create A Bundle';
    btn.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
      color: #000;
      font-weight: 600;
      padding: 14px 32px;
      border-radius: 35px;
      box-shadow: 0 8px 24px #000000;
      z-index: 2;
      cursor: pointer;
      font-family: inherit;
      display: none;
      font-size: 16px;
      white-space: nowrap;
    `;
    btn.addEventListener('click', () => {
      window.bundleAppStepperOpen = true;
      updateMobileFooterVisibility();
    });
    document.body.appendChild(btn);
  }

  function updateMobileFooterVisibility() {
    const isMobile = window.innerWidth <= 900;
    if (!isMobile) return;

    const footer = getFooter();
    const createBtn = $('#bundle-mobile-create-btn');
    if (!footer || !createBtn) return;

    if (window.bundleAppStepperOpen) {
      footer.style.setProperty('transform', 'translateY(0)', 'important');
      footer.style.setProperty('visibility', 'visible', 'important');
      createBtn.style.display = 'none';
      document.body.style.setProperty('padding-bottom', '96px', 'important');
      document.body.classList.add('bundle-stepper-opened');
    } else {
      footer.style.setProperty('transform', 'translateY(150%)', 'important');
      footer.style.setProperty('visibility', 'hidden', 'important');
      createBtn.style.display = 'block';
      document.body.style.setProperty('padding-bottom', '0', 'important');
      document.body.classList.remove('bundle-stepper-opened');
    }
  }

  // ── Sticky footer ──────────────────────────────────────────
  function initStickyFooter() {
    const isMobile = window.innerWidth <= 900;
    initMobileCreateButton();

    if (isMobile) {
      // ── Mobile: show native sticky footer (identical to custom-stepper) ──
      const footers = $$(FOOTER_SEL);
      if (footers.length === 0) return;

      // Prefer the freshly-rendered footer (not yet moved to body)
      const freshFooter = Array.from(footers).find(f => f.parentElement !== document.body);
      const footer = freshFooter || footers[0];

      // Remove duplicate footers already appended to body
      Array.from(footers).forEach(f => {
        if (f !== footer && f.parentElement === document.body) f.remove();
      });

      if (footer.parentElement !== document.body) document.body.appendChild(footer);

      const styles = {
        position: 'fixed',
        bottom: '12px', left: '12px', right: '12px', width: 'auto',
        'z-index': '2', background: 'white',
        'border-radius': '60px',
        'box-shadow': '0 8px 24px #000000',
        padding: '8px 10px', 'box-sizing': 'border-box',
        display: 'block', opacity: '1', 'pointer-events': 'auto',
        overflow: 'visible',
        transition: 'transform 0.3s ease-in-out, visibility 0.3s ease-in-out'
      };
      Object.entries(styles).forEach(([k, v]) => footer.style.setProperty(k, v, 'important'));

      const innerDiv = Array.from(footer.children).find(c => c.tagName === 'DIV');
      if (innerDiv) {
        Object.entries({
          maxWidth: '100%', margin: '0 auto', width: '100%', display: 'flex',
          flexWrap: 'nowrap', alignItems: 'center', justifyContent: 'space-between'
        }).forEach(([k, v]) => innerDiv.style.setProperty(k, v, 'important'));
      }

      updateMobileFooterVisibility();

      if (!window.gbbStickyListenerAttached) {
        window.addEventListener('resize', updateMobileFooterVisibility, { passive: true });
        window.gbbStickyListenerAttached = true;
      }
      setTimeout(updateMobileFooterVisibility, 100);
      setTimeout(updateMobileFooterVisibility, 500);

    } else {
      // ── Desktop: hide footer — sidebar stepper is used instead ──
      const footer = getFooter();
      if (!footer) return;

      const createBtn = $('#bundle-mobile-create-btn');
      if (createBtn) createBtn.style.display = 'none';

      if (footer.parentElement !== document.body) document.body.appendChild(footer);

      Object.entries({
        position: 'fixed', bottom: '-500px', left: '0',
        visibility: 'hidden', opacity: '0', pointerEvents: 'none', zIndex: '-1'
      }).forEach(([k, v]) => footer.style.setProperty(k, v, 'important'));

      document.body.style.removeProperty('padding-bottom');
    }
  }

  function adjustParentSectionPadding() {
    const isMobile = window.innerWidth <= 900;
    if (!isMobile) return;
    const wrapper = $('.gbbAddGiftBoxPageWrapper') || $('#bundle-layout-wrapper');
    if (!wrapper) return;
    const section = wrapper.closest('div[class*="section-template-"]') || wrapper.closest('.page-width');
    if (section) {
      section.style.setProperty('padding-left', '0', 'important');
      section.style.setProperty('padding-right', '0', 'important');
    }
  }

  // ── Init ───────────────────────────────────────────────────
  function init() {
    let syncTimer = null;

    function throttledSync() {
      if (syncTimer) return;
      syncTimer = setTimeout(() => {
        syncTimer = null;
        clearButtonText();
        injectDiscountTags();
        convertSelectToTabs();
        adjustParentSectionPadding();
        const footer = getFooter();
        if (footer && !window.bundleAppShowcasingPrices) syncStepperState();
      }, 150);
    }


    function moveSizeChartLink() {
      const modal = document.querySelector('.gbbProductVariantModalMainContainer');
      if (!modal) return;

      const link = modal.querySelector('.bundle-size-chart-link');

      const sizeContainer = modal.querySelector(
        '.gbbProductVariantOptionContainer[optionid="Size"]'
      );

      const label = sizeContainer?.querySelector(
        '.gbbProductVariantOptionLabel'
      );

      const values = sizeContainer?.querySelector(
        '.gbbProductVariantOptionValuesContainer'
      );

      if (!link || !sizeContainer || !label || !values) return;

      // Already moved
      if (sizeContainer.contains(link)) return;

      // Move link directly into Size container
      sizeContainer.insertBefore(link, values);
    }


    const observer = new MutationObserver(() => {
      convertSelectToTabs();
      adjustParentSectionPadding();
      if (window.innerWidth > 900) {
        injectStepperSidebar(getTotalSteps());
      }
      injectSizeChart();
      if (window.bundleAppShowcasingPrices) return;

      const footer = getFooter();
      if (!footer) return;

      throttledSync();

      const first = footer.childNodes[0];
      if (first?.nodeType === 3 && first.textContent.trim()) first.textContent = "";

      initStickyFooter();
      moveSizeChartLink();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      clearButtonText();
      adjustParentSectionPadding();
      // Only inject sidebar stepper on desktop
      if (window.innerWidth > 900) {
        injectStepperSidebar(getTotalSteps());
      }
      syncStepperState();
      initStickyFooter();
      injectSizeChart();
    }, 100);

    // Re-run initStickyFooter on resize so switching from mobile->desktop works
    window.addEventListener('resize', () => {
      adjustParentSectionPadding();
      initStickyFooter();
      if (window.innerWidth > 900 && !$('#bundle-sticky-stepper-panel')) {
        injectStepperSidebar(getTotalSteps());
      }
    }, { passive: true });

    document.addEventListener("click", handleStepperClick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Inject styles directly via JS to completely bypass Shopify CSS cache
(function () {
  const style = document.createElement('style');
  style.innerHTML = `
    body.bundle-stepper-opened .gbbAddProductsPageFooterHTML,
    body.bundle-stepper-opened .gbbPageFooterHTML,
    body.bundle-stepper-opened .gbbAddGiftBoxPageFooterHTML {
      transform: translateY(0) !important;
      visibility: visible !important;
    }
    .gbbDiscountFooterHTML,
    .gbbAddProductsPageFooterHTML .gbbDiscountFooterHTML {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      pointer-events: none !important;
    }
    .bundle-app-new-step-img {
      display: block !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      object-fit: cover !important;
      object-position: center !important;
      box-sizing: border-box !important;
    }
    @media (max-width: 900px) {
      .bundle-app-new-step {
        flex: 0 1 60px !important;
        width: 100% !important;
        max-width: 60px !important;
        aspect-ratio: 1 / 1 !important;
      }
      .bundle-app-new-step-box {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
        aspect-ratio: 1 / 1 !important;
        border-radius: 50% !important;
        box-sizing: border-box !important;
      }
      .bundle-app-new-step-img {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
        border-radius: 50% !important;
        object-fit: cover !important;
        display: block !important;
        box-shadow: none !important;
        box-sizing: border-box !important;
      }
      .bundle-app-new-step.filled .bundle-app-new-step-box {
        border: none !important;
        padding: 0 !important;
        overflow: visible !important;
        border-radius: 50% !important;
        filter: none !important;
        box-shadow: none !important;
      }
    }
    @media (max-width: 768px) {
      .bundle-app-new-step {
        flex: 0 1 56px !important;
        max-width: 56px !important;
      }
    }
    @media (max-width: 480px) {
      .bundle-app-new-step {
        flex: 0 1 50px !important;
        max-width: 50px !important;
      }
    }
    @media (max-width: 400px) {
      .bundle-app-new-step {
        flex: 0 1 46px !important;
        max-width: 46px !important;
      }
    }
    @media (max-width: 340px) {
      .bundle-app-new-step {
        flex: 0 1 40px !important;
        max-width: 40px !important;
      }
    }
  `;
  document.head.appendChild(style);
})();